function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { triggerEvent } from '@demant/wdh';
var FooterComponent = function FooterComponent(_ref) {
  var footerData = _ref.footerData,
    videoIframe = _ref.videoIframe,
    onDiscoverMore = _ref.onDiscoverMore,
    isFoldOut = _ref.isFoldOut,
    randomNumber = _ref.randomNumber,
    isFoldOutContent = _ref.isFoldOutContent;
  useEffect(function () {
    window.DGS.Event.getInstance().trigger('link-embed-code-detected');
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, footerData && /*#__PURE__*/React.createElement("div", {
    className: "brainhearing-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "brainhearing-footer__thumbnails-container"
  }, footerData.map(function (element, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ThumbnailsLinks, {
      element: element,
      index: index
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "brainhearing-footer__button-container"
  }, /*#__PURE__*/React.createElement(ButtonsLinks, {
    element: footerData[0],
    videoIframe: videoIframe,
    onDiscoverMore: onDiscoverMore,
    isFoldOut: isFoldOut,
    randomNumber: randomNumber,
    isFoldOutContent: isFoldOutContent
  }))));
};
var ThumbnailsLinks = function ThumbnailsLinks(_ref2) {
  var element = _ref2.element,
    index = _ref2.index;
  return /*#__PURE__*/React.createElement("a", {
    href: element.link,
    className: "brainhearing-footer__thumbnails-container__item brain-hearing-footer-".concat(index + 1),
    key: index
  }, /*#__PURE__*/React.createElement("div", {
    className: "brainhearing-footer__thumbnails-container__item__image"
  }, /*#__PURE__*/React.createElement("img", {
    src: element.image
  })), /*#__PURE__*/React.createElement("span", {
    className: "brainhearing-footer__thumbnails-container__item__desc"
  }, element.title));
};
var ButtonsLinks = function ButtonsLinks(_ref3) {
  var element = _ref3.element,
    videoIframe = _ref3.videoIframe,
    onDiscoverMore = _ref3.onDiscoverMore,
    isFoldOut = _ref3.isFoldOut,
    randomNumber = _ref3.randomNumber,
    isFoldOutContent = _ref3.isFoldOutContent;
  var _useState = useState(element.watchTheFilm),
    _useState2 = _slicedToArray(_useState, 2),
    watchFilmButton = _useState2[0],
    setWatchTheFilm = _useState2[1];
  var _useState3 = useState(element.discoverMore),
    _useState4 = _slicedToArray(_useState3, 2),
    discoverMore = _useState4[0],
    setDiscoverMore = _useState4[1];
  var discoverMoreFunction = function discoverMoreFunction(e) {
    e.preventDefault();
    onDiscoverMore(e);
    if (!isFoldOut) {
      setTimeout(function () {
        document.querySelector(".foldout.show[data-scroll=\"".concat(randomNumber, "\"]")).scrollIntoView(true);
      }, 200);
    }
    return false;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, watchFilmButton && /*#__PURE__*/React.createElement("a", {
    href: "#",
    title: videoIframe,
    className: "button video-icon"
  }, watchFilmButton), /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "button ".concat(isFoldOutContent ? '' : 'hidden'),
    onClick: function onClick(e) {
      discoverMoreFunction(e);
    }
  }, !isFoldOut ? discoverMore : element.closeLink));
};
export default FooterComponent;